// we was fetching ip address from this url "https://api.ipify.org/?format=json"
const getUserIpaddress = async (
  np = 0,
  url = "https://64dukuz4mf.execute-api.us-east-2.amazonaws.com/getIpAddress"
) => {
  try {
    if (np > 5) {
      if (
        url ===
        "https://64dukuz4mf.execute-api.us-east-2.amazonaws.com/getIpAddress"
      ) {
        return getUserIpaddress(0, "https://api.ipify.org/?format=json");
      }
      return false;
    }
    console.log("fetch user ipaddress");
    const response = await fetch(url);
    if (response.status !== 200) {
      console.log(response);
      return getUserIpaddress(np + 1, url);
    }
    const userId = await response.json();
    // const userId = result.ip.replaceAll(".", "");
    return userId;
  } catch (error) {
    console.log(error);
    return getUserIpaddress(np + 1, url);
  }
};

// generate unique key to replace ipaddress
const generateUniqueKey = () => {
  try {
    let chars = "0123456789abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let passwordLength = 32;
    let password = "";
    for (let i = 0; i <= passwordLength; i++) {
      let randomNumber = Math.floor(Math.random() * chars.length);
      password += chars.substring(randomNumber, randomNumber +1);
    }
    return password;
  } catch (error) {
    console.error("generateUniqueKey ===> ",error)
  }
}


let firbaseData;
const AuthenticateFirebase = async () => {
  try {
    const authentication = await new Promise((resolve) =>
      firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
          // console.log(user);
          // console.log("store connected to firebase")
          firbaseData = user;

          resolve(true);
        } else {
          var email = "imed@example.com";
          var password = "23061998qwerty";
          // [START auth_signIn_password]
          firebase
            .auth()
            .signInWithEmailAndPassword(email, password)
            .then(async (user) => {
              // Signed in
              // console.log(user);
              firbaseData = user;
              resolve(true);
              // ...
            })
            .catch((error) => {
              var errorCode = error.code;
              var errorMessage = error.message;
              console.log(errorCode, errorMessage);
              resolve(false);
            });
        }
      })
    );
    return authentication;
  } catch (error) {
    console.log(error);
    return;
  }
};

const firebase_fuctions = {
  GetGlobalCartID: async () => {
    try {
      console.log("uniqueNumber_Cookies ====> ", uniqueNumber_Cookies);
      const userRef = firebase.database().ref("users/" + uniqueNumber_Cookies);
      // const now = Date.now();
      return await userRef.once("value").then(async (snapshot) => {
        // console.log(snapshot.exists());
        if (snapshot.exists()) {
          console.log(snapshot.val());
          const data = snapshot.val();
          return data?.cartID;
        } else {
          return false;
        }
      });
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  StoreCartID: async (cartId) => {
    try {
      const userRef = firebase.database().ref("users/" + uniqueNumber_Cookies);
      const now = Date.now();

      userRef.set({
        cartID: cartId,
        date: now,
      });

      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
};

const getGlobalCartIDFromFirebase = async () => {
  try {
    const firebaseAuthenticated = await AuthenticateFirebase();

    if (!firebaseAuthenticated) {
      console.log("======> firebase not authenticated .......");
      return false;
    }
    const response = await firebase_fuctions.GetGlobalCartID();
    if (!response) {
      console.log("there is no cartid linked by that ipAddress");
      return false;
    }
    return response;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const createCarte = async () => {
  try {
    const Body = `
        mutation cartCreate  {
          cartCreate {
            cart {
              discountCodes{code}
              id
              checkoutUrl
            }
            userErrors {
              code
              field
              message
            }
          }
        }
      `;
    const data = await CertorgraphqlPostRequest(Body);
    if (data?.data?.cartCreate?.userErrors.length !== 0) {
      console.log(data);
      return false;
    }
    cartItems = data?.data;
    return data?.data?.cartCreate?.cart?.id;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const createNewCartAndStoreItOnFirebaseAndCookies = async (uniqueNumber_Cookies) => {
  try {
    const newCartID = await createCarte();
    setCookie("cartID", newCartID, 13);
    const result = await firebase_fuctions.StoreCartID(
      newCartID,
      uniqueNumber_Cookies
    );
    if (!result) {
      console.log("new cart id not stored on firebase and on cookies");
      return false;
    }
    //globalCartID_Cookies = newCartID;
    console.log("new cart id stored on firebase and on cookies");
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const creatProductList = (cartData) => {
  try {
    let productList = [];
    cartData.data.cart.lines.edges.map((item) => {
      productList.push({
        attributes: item.node.attributes,
        merchandiseId: item.node.merchandise.id,
        quantity: parseInt(item.node.quantity),
      });
    });
    return productList;
  } catch (error) {
    console.log(error);
    return;
  }
};

const filterTwoReference = (arr1, arr2) => {
  try {
    let res = [];
    res = arr1.filter((el) => {
      return !arr2.find((element) => {
        return element.merchandiseId === el.merchandiseId;
      });
    });
    return res;
  } catch (error) {
    console.log(error);
    return [];
  }
};

const updateCart = async (items, cartID) => {
  try {
    const Body = `
        mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
          cartLinesAdd(cartId: $cartId, lines: $lines) {
            cart {
              id
              discountCodes{code}
              checkoutUrl
              estimatedCost {
                subtotalAmount {
                  amount
                  currencyCode
                }
              }
              lines(first: 100) {
                edges {
                  node {
                    id
                    quantity
                    attributes {
                      key
                      value
                    }
                    estimatedCost {
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                    }
                    merchandise {
                      ... on ProductVariant {
                        id
                        sku
                        image {
                          url
                        }
                        priceV2 {
                          amount
                        }
                        product {
                          vendor
                          title
                          handle
                          onlineStoreUrl
                        }
                        selectedOptions {
                          name
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
        }
      }
    `;

    const Variables = {
      cartId: cartID,
      lines: items,
    };

    const data = await CertorgraphqlPostRequest(Body, Variables);
    if (!data?.data?.cartLinesAdd?.cart?.lines) {
      console.log(
        "something wrong in getAllCartItems() that fetch all items from global cart"
      );
      console.log(data);
      return false;
    }
    cartItems = data?.data?.cartLinesAdd;
    return data?.data?.cartLinesAdd;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const main = async () => {
  try {
    // get globalCart from firebase
    if(!uniqueNumber_Cookies){
      uniqueNumber_Cookies = generateUniqueKey();
      setCookie("uniqueNumber", uniqueNumber_Cookies, 13)
    }
    // get globalCart from firebase
    const globalCartID_Firebase = await getGlobalCartIDFromFirebase();

    // if global cart id not exist in cookies and firebase
    if (!globalCartID_Firebase && !globalCartID_Cookies) {
      // then create new cart and store it in cookies and firebase
      const result = await createNewCartAndStoreItOnFirebaseAndCookies();
      if (!result) {
        return false;
      }
      return true;
    }

    // if global cart id not exist in cookies and  exist in firebase
    if (globalCartID_Firebase && !globalCartID_Cookies) {
      const cartStatus = await fetchCartLines(globalCartID_Firebase);
      // if global cart id that stored on firebase expired
      if (!cartStatus) {
        // then create new cart and store it in cookies and firebase
        //const result = await createNewCartAndStoreItOnFirebaseAndCookies();

        //if (!result) {
         // return false;
        //}
        return true;
      }

      // if it's not expired the save it on cookies
      setCookie("cartID", globalCartID_Firebase, 13);
      //globalCartID_Cookies = globalCartID_Firebase;
      return true;
    }

    // if global cart id not exist in firebase and  exist in cookies
    if (!globalCartID_Firebase && globalCartID_Cookies) {
      // check globalCartID_Cookies lifetime and set it on firebase
      const cartStatus = await fetchCartLines(globalCartID_Cookies);
      // if global cart id that stored on firebase expired
      if (!cartStatus) {
        // then create new cart and store it in cookies and firebase
        const result = await createNewCartAndStoreItOnFirebaseAndCookies();
        if (!result) {
          return false;
        }
        return true;
      }

      // if it's not expired the save it on firebasse
      console.log("cart id stored in to firebase ");
      firebase_fuctions.StoreCartID(globalCartID_Cookies);
      return true;
    }

    // if global cart id exist in firebase and exist in cookies
    if (globalCartID_Firebase && globalCartID_Cookies) {
      // check if they are identical if yes check cart life time
      console.log("cart id exist in both firebase and cookies");
      if (globalCartID_Firebase === globalCartID_Cookies) {
        console.log("cart id that stored in cookies and firebase are equal");

        const globalCartID__Status = await fetchCartLines(globalCartID_Cookies);
        if (!globalCartID__Status) {
          const result = await createNewCartAndStoreItOnFirebaseAndCookies();
          if (!result) {
            return false;
          }
          return true;
        }
        console.log("globalCartID__Status ===> ", globalCartID__Status)
        return true;
      }

      // if not identical then check if they are expired or not
      let globalCartID_Cookies_Status;
      let globalCartID_Firebase_Status;

      const statusesPromise = Promise.allSettled([
        fetchCartLines(globalCartID_Cookies),
        fetchCartLines(globalCartID_Firebase),
      ]);
      const fetchingGlobalCartsItemsStatuses = await statusesPromise;

      fetchingGlobalCartsItemsStatuses.forEach(
        (GlobalCartItemsStatus, index) => {
          try {
            if (GlobalCartItemsStatus.status === "rejected") {
              console.log(GlobalCartItemsStatus.reason);
            }
            if (index === 0) {
              globalCartID_Cookies_Status = GlobalCartItemsStatus.value;
            }
            if (index === 1) {
              globalCartID_Firebase_Status = GlobalCartItemsStatus.value;
            }
          } catch (error) {
            console.log(error);
          }
        }
      );

      // if globalCartID_Firebase_Status it's not expired and globalCartID_Cookies_Status expired
      // then update cookies
      if (globalCartID_Firebase_Status && !globalCartID_Cookies_Status) {
        console.log(
          "the cart id that stored in cookies is expired and the other id on firebase is still active"
        );
        setCookie("cartID", globalCartID_Firebase, 13);
        //globalCartID_Cookies = globalCartID_Firebase;

        return true;
      }

      // if globalCartID_Firebase_Status expired and globalCartID_Cookies_Status it's not expired
      // then update firebase
      if (!globalCartID_Firebase_Status && globalCartID_Cookies_Status) {
        console.log(
          "the cart id that stored in firebase is expired and the other id on cookies is still active"
        );
        firebase_fuctions.StoreCartID(globalCartID_Cookies, uniqueNumber_Cookies);
        return true;
      }

      if (!globalCartID_Firebase_Status && !globalCartID_Cookies_Status) {
        // then create new cart and store it in cookies and firebase
        console.log(
          "both cart id that stored in firebase and cookies are expired"
        );
        const result = await createNewCartAndStoreItOnFirebaseAndCookies();
        if (!result) {
          return false;
        }
        return true;
      }

      console.log(
        "both cart id that stored in firebase and cookies are not expired"
      );

      // if both of then still active get product of globalCartID_Cookies
      // and update globalCartID_Firebase with items that not exist on it
      const globalCartID_Firebase_ProductsList = creatProductList(
        globalCartID_Firebase_Status
      );
      const globalCartID_Cookies_ProductsList = creatProductList(
        globalCartID_Cookies_Status
      );

      // if global cart id that exist in cookies doesn't have any item
      // then replace it with global cart id that stored in firebase
      if (globalCartID_Cookies_ProductsList.length === 0) {
        console.log(
          "global cart id that exist in cookies doesn't have any item then replace it with global cart id that stored in firebase"
        );
        setCookie("cartID", globalCartID_Firebase, 13);
        return true;
      }

      // get products from local cart that not appear in global cart
      const productMustAdded = filterTwoReference(
        globalCartID_Cookies_ProductsList,
        globalCartID_Firebase_ProductsList
      );

      // if there is no update need to be maked in globalCartID_Firebase then set it on cookies
      if (productMustAdded.length === 0) {
        console.log(
          "there are no updates need to be maked in globalCartID_Firebase then set it on cookies "
        );
        setCookie("cartID", globalCartID_Firebase, 13);
        return true;
      }

      // update global cart
      console.log(
        "there are updates need to be maked in globalCartID_Firebase then set it on cookies "
      );
      await updateCart(productMustAdded, globalCartID_Firebase);
      // update cookies with cart id stored in firebase
      setCookie("cartID", globalCartID_Firebase, 13);
      //globalCartID_Cookies = globalCartID_Firebase;
      return true;
    }

    // =====================================
    // // check cart still exist
    // const globalCartItems_cookies = await fetchCartLines(globalCartID_Cookies);
    // //============================
  } catch (error) {
    console.log(error);
    return false;
  }
};

const updateGlobalCartID = async () => {
  try {
    // clear local cart
    //RestApi_GET("/cart/clear.js");
    // =================
    //const globalCartStatus = await main();
    const cartStatus = await fetchCartLines(globalCartID_Cookies);
    console.log("cartStatus updateGlobalCartID", cartStatus)
    if (!cartStatus) {
      console.log("there is problem in fetching cart or cart is not ready yet");
      return false;
    }
    if (document.location.href.includes("https://schuttsports.com/cart")) {
      try {
        //display_main_cart_items();
      } catch (error) {
        console.log(error)
        if (error instanceof ReferenceError) {
          await new Promise((resolve) => setTimeout(resolve, 1500));
          //display_main_cart_items();
        }
      }

      return true;
    }
    document.addEventListener("globalcartID:updated", async () => {
      console.log("globalcartID:updated event");
      // deactivate cart loader
      deactivateCartLoader();
      display_mini_cart_items();
    });
    document.documentElement.dispatchEvent(
      new CustomEvent("globalcartID:updated", {
        bubbles: true,
      })
    );
    document.addEventListener("globalVariant:add", async () => {
      console.log("globalVariant:add");
      await new Promise((resolve) => setTimeout(resolve, 1000));
      deactivateCartLoader();
      display_mini_cart_items();
    });
  } catch (error) {
    console.log(error);
  }
};
document.addEventListener("DOMContentLoaded", function(event) {
     updateGlobalCartID();
  });

